(function(){
  function init(root){
    if(root.dataset.init) return; root.dataset.init = '1';
    var section = root.closest('.cl-reel');
    var track = root.querySelector('[data-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var nav = section.querySelector('[data-nav]');
    var cur = section.querySelector('[data-cur]');
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-dots] button'));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var active = -1, visible = false, raf = 0, userStarted = null;
    if(!slides.length) return;

    function center(i, smooth){
      var el = slides[i]; if(!el) return;
      var left = el.offsetLeft - (track.clientWidth - el.offsetWidth) / 2;
      track.scrollTo({left: left, behavior: smooth === false ? 'auto' : 'smooth'});
    }
    function stop(el, reset){
      var v = el.querySelector('[data-video]'); if(!v) return;
      v.pause(); v.muted = true; v.loop = true; el.classList.remove('is-playing','is-sound','is-paused','is-loading');
      var sb = el.querySelector('[data-sound]'); if(sb) sb.setAttribute('aria-pressed','false');
      if(reset){ try{ v.currentTime = 0; }catch(e){} }
    }
    function preview(el){
      var v = el.querySelector('[data-video]'); if(!v || reduce || !visible) return;
      v.muted = true; var p = v.play(); if(p && p.catch) p.catch(function(){});
    }
    function setActive(i){
      if(i === active) return;
      slides.forEach(function(el, k){
        var on = k === i;
        el.classList.toggle('is-active', on);
        if(!on) stop(el, true);
      });
      active = i;
      if(cur) cur.textContent = ('0' + (i + 1)).slice(-2);
      dots.forEach(function(d, k){ d.classList.toggle('is-on', k === i); d.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      if(nav){ nav.querySelector('[data-prev]').disabled = i === 0; nav.querySelector('[data-next]').disabled = i === slides.length - 1; }
      preview(slides[i]);
    }
    function measure(){
      var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bestD = Infinity;
      slides.forEach(function(el, k){
        var c = el.offsetLeft + el.offsetWidth / 2, d = Math.abs(c - mid);
        var t = Math.min(1, d / el.offsetWidth);
        el.style.setProperty('--d', t.toFixed(3));
        if(d < bestD){ bestD = d; best = k; }
      });
      setActive(best);
    }
    var dragging = false, dragMoved = false, dragX = 0, dragLeft = 0;
    track.addEventListener('pointerdown', function(e){
      if(e.pointerType !== 'mouse' || e.button !== 0) return;
      dragging = true; dragMoved = false; dragX = e.clientX; dragLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function(e){
      if(!dragging) return;
      var dx = e.clientX - dragX;
      if(Math.abs(dx) > 4){ dragMoved = true; }
      track.scrollLeft = dragLeft - dx;
    });
    function endDrag(){
      if(!dragging) return;
      dragging = false; track.classList.remove('is-dragging');
      measure();
      if(dragMoved){ center(active); setTimeout(function(){ dragMoved = false; }, 60); }
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', function(e){ if(dragMoved){ e.preventDefault(); e.stopPropagation(); } }, true);
    track.addEventListener('dragstart', function(e){ e.preventDefault(); });
    track.addEventListener('scroll', function(){ if(!raf) raf = requestAnimationFrame(function(){ raf = 0; measure(); }); }, {passive:true});
    window.addEventListener('resize', function(){ center(active, false); measure(); });

    slides.forEach(function(el, k){
      var v = el.querySelector('[data-video]');
      var play = el.querySelector('[data-play]');
      var sound = el.querySelector('[data-sound]');
      var bar = el.querySelector('[data-progress]');
      var len = el.querySelector('[data-len]');
      function startWithSound(){
        v.loop = false; try{ v.currentTime = 0; }catch(err){}
        v.muted = false;
        el.classList.add('is-playing','is-sound','is-loading'); el.classList.remove('is-paused');
        if(sound) sound.setAttribute('aria-pressed','true');
        var p = v.play();
        if(p && p.catch) p.catch(function(){
          v.muted = true; el.classList.remove('is-sound'); if(sound) sound.setAttribute('aria-pressed','false');
          var q = v.play(); if(q && q.catch) q.catch(function(){ el.classList.remove('is-playing','is-loading'); });
        });
      }
      el.addEventListener('click', function(e){
        if(k !== active){ e.preventDefault(); center(k); return; }
        if(!v) return;
        if(e.target.closest('[data-sound]')){
          v.muted = !v.muted; el.classList.toggle('is-sound', !v.muted); if(sound) sound.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
          if(v.paused){ var r = v.play(); if(r && r.catch) r.catch(function(){}); }
          return;
        }
        if(el.classList.contains('is-loading')) return;
        if(el.classList.contains('is-paused')){ el.classList.remove('is-paused'); var r2 = v.play(); if(r2 && r2.catch) r2.catch(function(){}); return; }
        if(!el.classList.contains('is-playing')){ startWithSound(); return; }
        v.pause(); el.classList.add('is-paused');
      });
      if(v){
        v.addEventListener('timeupdate', function(){
          if(bar && v.duration){ bar.style.width = (v.currentTime / v.duration * 100) + '%'; }
          if(len && el.classList.contains('is-playing') && v.duration){
            var r = Math.max(0, v.duration - v.currentTime); len.textContent = Math.floor(r/60) + ':' + ('0' + Math.floor(r%60)).slice(-2);
          }
        });
        v.addEventListener('playing', function(){ el.classList.remove('is-loading'); });
        v.addEventListener('canplay', function(){ if(!v.paused) el.classList.remove('is-loading'); });
        v.addEventListener('waiting', function(){ if(el.classList.contains('is-playing') && !el.classList.contains('is-paused')) el.classList.add('is-loading'); });
        v.addEventListener('error', function(){ el.classList.remove('is-loading'); });
        v.addEventListener('ended', function(){
          stop(el, true);
          if(bar) bar.style.width = '0%';
          if(len) len.textContent = len.getAttribute('data-len-orig') || len.textContent;
          preview(el);
        });
        if(len) len.setAttribute('data-len-orig', len.textContent);
      }
    });

    if(nav){
      nav.querySelector('[data-prev]').addEventListener('click', function(){ center(Math.max(0, active - 1)); });
      nav.querySelector('[data-next]').addEventListener('click', function(){ center(Math.min(slides.length - 1, active + 1)); });
    }
    dots.forEach(function(d, k){ d.addEventListener('click', function(){ center(k); }); });
    root.addEventListener('keydown', function(e){
      if(e.key === 'ArrowLeft'){ e.preventDefault(); center(Math.max(0, active - 1)); }
      if(e.key === 'ArrowRight'){ e.preventDefault(); center(Math.min(slides.length - 1, active + 1)); }
    });

    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){
        visible = en[0].isIntersecting;
        if(visible && active > -1){ var el = slides[active]; if(!el.classList.contains('is-playing')) preview(el); }
        else if(active > -1){ var vv = slides[active].querySelector('[data-video]'); if(vv) vv.pause(); }
      }, {threshold: .35}).observe(root);
    } else { visible = true; }

    var start = parseInt(root.dataset.start || '0', 10) || 0;
    center(Math.min(start, slides.length - 1), false);
    requestAnimationFrame(measure);
  }
  function boot(){ document.querySelectorAll('[data-reel]').forEach(init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
